<div *ngIf="alertaService.exibirAlerta">
  <div class="alert alert-success fade show m-0 row border-radius-0" role="alert">
    <div class="align-items-center col d-flex">
      <img src="assets/imgs/icones/info-branco.svg" alt="" class="me-2">
      <span>{{alertaService.mensagemTexto}}</span>
    </div>
    <div class="text-end col">
      <button class="btn" (click)="alertaService.fechar()">
        <img src="assets/imgs/icones/close.svg" alt="">
      </button>
    </div>
  </div>
</div>
